import { ShaderLib as ThreeShaderLib } from 'three/src/renderers/shaders/ShaderLib';
import { mergeUniforms } from 'three/src/renderers/shaders/UniformsUtils';
import { ShaderChunk } from './ShaderChunk';

const THREE = require('three');

const Uniforms = {
    basicGradientMap: {
        color0: { value: new THREE.Color(0x000000) },
        color1: { value: new THREE.Color(0xffffff) },
        tintInfluence: { value: 0 }
    },
    time: {
        time: { value: 0 }
    }
};

const ShaderLib = {
    basicGradientMap: {
        uniforms: mergeUniforms([
            ThreeShaderLib.basic.uniforms,
            Uniforms.basicGradientMap
        ]),

        vertexShader: ThreeShaderLib.basic.vertexShader,
        fragmentShader: ShaderChunk.meshbasicgradientmapFrag
    },
    basicGradientMapAnimated: {
        uniforms: mergeUniforms([
            ThreeShaderLib.basic.uniforms,
            Uniforms.basicGradientMap,
            Uniforms.time,
            {
                animInfluence: { value: 0 }
            }
        ]),

        vertexShader: ShaderChunk.meshbasicgradientmapanimatedVert,
        fragmentShader: ShaderChunk.meshbasicgradientmapanimatedFrag
    }
};

export { ShaderLib };
